<template>
  <div class="bcb-partner-list w-100">
    <basic-subheader>
      <template v-slot:actions>
        <!-- Bộ lọc dropdown -->
        <b-dropdown
          id="bcb-partner-filter"
          class="dropdown-form-filter"
          no-caret
          right
        >
          <template #button-content>
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
            </span>
            Bộ lọc
          </template>
          <h6 class="d-flex align-items-center mb-0 p-4">
            <span class="svg-icon mr-3">
              <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
            </span>
            Bộ lọc
          </h6>
          <b-dropdown-divider />
          <b-dropdown-form>
            <b-container class="p-0">
              <b-row>
                <b-col cols="4">
                  <basic-input
                    label="Tên đối tác"
                    placeholder="Nhập tên đối tác"
                    name="name"
                    :value.sync="filter.name"
                  />
                </b-col>
                <b-col cols="4">
                  <basic-input
                    label="Số điện thoại"
                    placeholder="Nhập số điện thoại"
                    name="phone"
                    :value.sync="filter.phone"
                  />
                </b-col>
                <b-col cols="4">
                  <basic-select
                    label="Trạng thái"
                    placeholder="Tất cả trạng thái"
                    name="isActive"
                    :options="activeOptions"
                    track-by="value"
                    value-label="text"
                    :value.sync="filter.isActive"
                  />
                </b-col>
              </b-row>
            </b-container>
          </b-dropdown-form>
          <b-dropdown-divider />
          <div class="d-flex align-items-center justify-content-lg-end m-0 p-4">
            <b-button class="btn ml-2" href="#" tabindex="0" @click="resetFilter">
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/refresh-cw.svg" />
              </span>
              Reset bộ lọc
            </b-button>
            <b-button class="btn ml-2" href="#" tabindex="0" @click="searchRequest">
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
              </span>
              Lọc dữ liệu
            </b-button>
          </div>
        </b-dropdown>

        <!-- Thêm đối tác -->
        <b-button
          v-if="isInsertPermission"
          class="btn btn-success ml-2"
          type="button"
          @click="$router.push({ name: 'bcb-partner-create' })"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
          </span>
          Thêm đối tác
        </b-button>
      </template>
    </basic-subheader>

    <b-overlay :show="loading">
      <b-container fluid class="bcb-partner-list__body mb-6 mt-6">
        <b-row>
          <b-col>
            <div class="card card-custom gutter-b">
              <div class="card-body mt-0">
                <template-table
                  :column="columns"
                  :data="items"
                  :paging="paging"
                  :select-action="false"
                  :search-action="false"
                  :table-action="true"
                  @change-page="onChangePage"
                  @search="searchRequest"
                  @reset="resetFilter"
                >
                  <template #body="{ item }">
                    <td>{{ item.name }}</td>
                    <td>{{ item.address || '—' }}</td>
                    <td>{{ item.phone || '—' }}</td>
                    <td>{{ item.email || '—' }}</td>
                    <td>
                      <b-badge :variant="item.isActive ? 'success' : 'secondary'">
                        {{ item.isActive ? 'Hoạt động' : 'Không hoạt động' }}
                      </b-badge>
                    </td>
                  </template>
                  <template #action="{ item }">
                    <action-dropdown
                      :value="item"
                      :show_view="true"
                      :show_copy="false"
                      :show_edit="isUpdatePermission"
                      :show_delete="isDeletePermission"
                      @view="viewItem"
                      @edit="editItem"
                      @delete="deleteItem"
                    />
                  </template>
                </template-table>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
export default {
  name: 'BcbPartnerList',
  data() {
    return {
      loading: false,
      items: [],
      filter: {
        name: null,
        phone: null,
        isActive: null,
      },
      activeOptions: [
        { value: true, text: 'Hoạt động' },
        { value: false, text: 'Không hoạt động' },
      ],
      paging: { page: 1, pageSize: 10, total: 0 },
      columns: [
        { key: 'name', label: 'Tên đối tác', style: 'width: 25%' },
        { key: 'address', label: 'Địa chỉ', style: 'width: 25%' },
        { key: 'phone', label: 'SĐT', style: 'width: 15%' },
        { key: 'email', label: 'Email', style: 'width: 20%' },
        { key: 'isActive', label: 'Trạng thái', style: 'width: 10%' },
      ],
    };
  },
  computed: {
    searchParams() {
      const p = {
        page: this.paging.page,
        size: this.paging.pageSize,
      };
      if (this.filter.name) p.name = this.filter.name;
      if (this.filter.phone) p.phone = this.filter.phone;
      if (this.filter.isActive?.value != null) p.isActive = this.filter.isActive.value;
      return p;
    },
  },
  watch: {
    'paging.page'() { this.loadData(); },
    'paging.pageSize'() { this.paging.page = 1; this.loadData(); },
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const res = await this.$api.get('BcbPartner', { params: this.searchParams });
        const raw = res?.data ?? res;
        const list = raw?.items ?? raw?.data?.items ?? (Array.isArray(raw) ? raw : []);
        this.items = list;
        this.paging.total = raw?.total ?? raw?.data?.total ?? list.length;
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi', msg: e?.message || 'Không thể tải danh sách đối tác.' });
      } finally {
        this.loading = false;
      }
    },
    searchRequest() {
      this.paging.page = 1;
      this.loadData();
      document.body.click();
    },
    resetFilter() {
      this.filter = { name: null, phone: null, isActive: null };
      this.paging.page = 1;
      this.loadData();
      document.body.click();
    },
    onChangePage(page) {
      this.paging.page = page;
      this.loadData();
    },
    viewItem(item) {
      this.$router.push({ name: 'bcb-partner-edit', params: { id: item.id } });
    },
    editItem(item) {
      this.$router.push({ name: 'bcb-partner-edit', params: { id: item.id } });
    },
    async deleteItem(item) {
      const confirmed = await this.$swal({
        title: 'Xác nhận xóa',
        text: `Bạn có chắc chắn muốn xóa đối tác "${item.name}"?`,
        icon: 'warning',
        buttons: {
          cancel: { text: 'Hủy', value: false, visible: true, className: 'btn btn-secondary' },
          confirm: { text: 'Xóa', value: true, visible: true, className: 'btn btn-danger' },
        },
      });
      if (!confirmed) return;
      try {
        this.loading = true;
        await this.$api.delete(`BcbPartner/${item.id}`);
        this.$toastr.s({ title: 'Thành công', msg: 'Đã xóa đối tác.' });
        this.loadData();
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi', msg: e?.message || 'Không thể xóa đối tác.' });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-form-filter {
  .dropdown-menu {
    .container {
      width: 700px;
    }
  }
}
</style>
